import type React from "react";

import type { IBenefitApolloClub } from "@/api/interfaces/benefitLayouts";
import AddIcon from "@/assets/svg/addItem_icon.svg?react";
import { Button, H1, H2, H5, P } from "@/base/components/Global";
import { Col } from "@/base/components/Layout";
import { navigateTo } from "@/base/utils/uriHelper";
import config from "@/constants/config";
import { NavigationPath } from "@/constants/navigation";
import { useAppSelector } from "@/store";
import { selectCurrentLanguage } from "@/store/language";
import { selectCurrentRegionPrefix } from "@/store/region";

type ApolloClubBlockProps = {
  apolloClub?: IBenefitApolloClub;
};

const ApolloClubBlock: React.FC<ApolloClubBlockProps> = ({ apolloClub }) => {
  const currentLanguage = useAppSelector(selectCurrentLanguage);
  const currentRegionPrefix = useAppSelector(selectCurrentRegionPrefix);

  if (!apolloClub) return null;

  const { topTitle, title, subTitle, content, cta } = apolloClub;
  return (
    <Col directionColumn>
      <Col col={12} directionColumn>
        <H2 noMargin>{topTitle}</H2>
        <H1 noMargin>{title}</H1>
        <H5 thin brandColor>
          {subTitle}
        </H5>

        <P cmsContent={content} />
      </Col>
      {cta?.label && (
        <Col col={12} fullWidth directionColumn>
          <Button
            action={() =>
              navigateTo(
                config.routerConfig.loyaltyProfileUrl,
                NavigationPath.SignUpStart,
                currentLanguage,
                currentRegionPrefix,
              )
            }
            transparentBrand
            prefixIcon={<AddIcon />}
          >
            {cta?.label}
          </Button>
        </Col>
      )}
    </Col>
  );
};

export default ApolloClubBlock;
